var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forms-field-type forms-field-parting-line"},[(_vm.frontend)?[_c('hr')]:[_c('hr')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }